import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const updateForm = 'Success';
const newForm = 'Success';

const FormSuccess = (props) => {
  const { formSuccess, setFormSuccess, isNewForm } = props;

  const handleCloseSnackbar = () => setFormSuccess(null);

  return (
    <>
      {formSuccess && (
        <Snackbar
          open
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
          autoHideDuration={6000}
        >
          <Alert
            severity='success'
            {...formSuccess}
            onClose={handleCloseSnackbar}
          >
            {isNewForm ? newForm : updateForm}
          </Alert>
        </Snackbar>
      )}
    </>
  );
};

export default FormSuccess;
